/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_List_Dir_ErrorInputs */

const es_tools_legajox_list_dir_error = /** @type {(inputs: Tools_Legajox_List_Dir_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al listar carpetas de Legajox`)
};

const en_tools_legajox_list_dir_error = /** @type {(inputs: Tools_Legajox_List_Dir_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error listing Legajox folders`)
};

/**
* | output |
* | --- |
* | "Error listing Legajox folders" |
*
* @param {Tools_Legajox_List_Dir_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_list_dir_error = /** @type {((inputs?: Tools_Legajox_List_Dir_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_List_Dir_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_list_dir_error(inputs)
	return en_tools_legajox_list_dir_error(inputs)
});
export { tools_legajox_list_dir_error as "tools.legajox.list_dir_error" }